import * as React from 'react'

import { MultiSwitch } from '~ui/components/formElements/MultiSwitch/MultiSwitch'
import { Text } from '~ui/components/typography/Text/Text'

import { TTipOption } from './TipInput'

const MIN_OPTION_WIDTH: PropsOf<typeof Text>['minWidth'] = `40px`

type TProps = NoChildren & {
  tipUnit: string
  isDisabled: boolean
  selectedTip: TTipOption
  tipOptions: RoA<TTipOption>
  onSelect: (tip: TTipOption) => void
}

/**
 * Multi switch with the available tip values.
 */
export const TipSelect: React.FC<TProps> = ({
  tipUnit,
  onSelect,
  tipOptions,
  isDisabled,
  selectedTip,
}) => {
  return (
    <MultiSwitch
      idProp={`id`}
      variant={`buttons`}
      onSelect={onSelect}
      options={tipOptions}
      isDisabled={isDisabled}
      selectedOption={selectedTip}
      renderLabel={(option, isSelected) => (
        <Text
          fontStyle={`boldSemi`}
          minWidth={MIN_OPTION_WIDTH}
          contrast={isSelected ? `high` : `normal`}
        >
          {`${option.value} ${tipUnit}`}
        </Text>
      )}
    />
  )
}
